export enum SpecialCombinedTprmFieldName {
    additionalInsured = 'additionalInsured',
    waiverOfSubrogationCompanyName = 'waiverOfSubrogationCompanyName',
}
